<section class="ctb-estimator-introduction" aria-labelledby="ctb-estimator-introduction-title">
	<h1 id="ctb-estimator-introduction-title" class="ctb-estimator-introduction__title">{{ state().title }}</h1>

	<p class="ctb-estimator-introduction__description">{{ state().description }}</p>
</section>